/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Notes_Toggle_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Toggle Notes" |
*
* @param {Event_Notes_Toggle_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_notes_toggle_aria_label = /** @type {((inputs?: Event_Notes_Toggle_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Notes_Toggle_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Basculer les notes")
	if (locale === "de") return /** @type {LocalizedString} */ ("Notizen umschalten")
	if (locale === "it") return /** @type {LocalizedString} */ ("Attiva/disattiva note")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Показать примечания")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cambiar notas")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("切换备注")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ノートを切り替える")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नोट्स टॉगल करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Alternar notas")
	return /** @type {LocalizedString} */ ("Toggle Notes")
});